import React from 'react';
import { IconCalendar31, IconRightArrow, IconTimePrimary } from '../../../components/buttons/IconButtons';
import ButtonActionsCard from '../../../components/buttons/ButtonActionsCard';
import moment from 'moment';
import IconCard from './IconCard';
import { DATE_TIME_FORMAT_NAME_MODEL, getTimeFormat } from '../../../Apis/functions';
import { getDateFormat } from './../../../Apis/functions';
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */

const WelcomeComponent = ({
    t,
    getWorkOffice,
    status,
    checkInFn,
    checkOutFn,
    total,
    hours,
    minutes,
    currentAction,
    actionHandlers,
    disabled = false,
}) => {
    return (
        <div className='home-office-container'>
            <div className='home-office-card-left'>
                <IconCard text={t('today')} Icon={IconCalendar31} />
            </div>

            <div className='p-3 p-md-4 box-shadow-primary-800-opacity-20-blur-100 border-radius-16px home-office-main-card background-general-00'>
                <p className='fs-20px fs-md-24px ibl-font-w-400 font-color-primary-950 mb-2'>{t('welcome_to')}</p>

                <p className='home-office-title font-color-primary-800 ibl-font-w-600 text-capitalize'>
                    {t('home_office')}
                </p>

                {(getWorkOffice?.checkIn || getWorkOffice?.checkOut) && (
                    <div className='d-flex flex-column border-radius-8px border-full-success-150 background-success-50 p-3 mt-3 mb-3 w-100'>
                        {getWorkOffice?.checkIn && (
                            <div className='d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-2'>
                                <p className='font-color-success-700 ibl-font-w-500 fs-16px mb-0'>
                                    {t('check_in_time')}
                                </p>

                                <p className='font-color-success-700 ibl-font-w-700 fs-16px mb-0 text-break'>
                                    {getDateFormat(
                                        getWorkOffice?.checkIn,
                                        false,
                                        DATE_TIME_FORMAT_NAME_MODEL.dateTimeWithSeconds,
                                    )}
                                </p>
                            </div>
                        )}

                        {getWorkOffice?.checkOut && (
                            <>
                                <div className='d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-2 mt-2'>
                                    <p className='font-color-success-700 ibl-font-w-500 fs-16px mb-0'>
                                        {t('check_out_time')}
                                    </p>

                                    <p className='font-color-success-700 ibl-font-w-700 fs-16px mb-0 text-break'>
                                        {getDateFormat(
                                            getWorkOffice?.checkOut,
                                            false,
                                            DATE_TIME_FORMAT_NAME_MODEL.dateTimeWithSeconds,
                                        )}
                                    </p>
                                </div>

                                <div className='border-bottom-success-150 my-2' />

                                <div className='d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-2'>
                                    <p className='font-color-success-700 ibl-font-w-500 fs-16px mb-0'>
                                        {t('total_time')}
                                    </p>

                                    <p className='font-color-success-700 ibl-font-w-700 fs-20px mb-0'>
                                        {`${hours}h ${minutes}m`}
                                    </p>
                                </div>
                            </>
                        )}
                    </div>
                )}

                {currentAction && (
                    <ButtonActionsCard
                        name={currentAction.name}
                        Icon={IconRightArrow}
                        id='btn_wc_status'
                        onClick={actionHandlers[status]}
                        disabled={disabled}
                        className='button-gradient-horizontal-primary background-linear-gradient-primary-800-500 p-3 w-100 mt-2'
                        iconProps='btn-icon-svg-32px btn-icon-svg-white'
                    />
                )}
            </div>

            <div className='home-office-card-right'>
                <IconCard text={t('track_time')} Icon={IconTimePrimary} />
            </div>
        </div>
    );
};

export default WelcomeComponent;
